import { AD_ENTITY_TYPES, RELYING_PARTIES_TYPES } from '@silverfort-nodelibs/common/utils/consts';

import groupIcon from '../../../common/Images/securiy_group.png';
import ouIcon from '../../../common/Images/ou.png';
import userIcon from '../../../common/Images/user.png';
import serverIcon from '../../../common/Images/server.png';
import applicationIcon from '../../../common/Images/application.svg';
import ipIcon from '../../../common/Images/ip_address.png';
import oktaIcon from '../../../common/Images/cloud_app_blue.svg';
import relyingPartiesIcon from '../../../common/Images/relying_parties_blue.svg';
import localAccountIcon from '../../../common/Images/local_account.svg';

export const ENTITY_TYPES_TO_ICONS = {
    [AD_ENTITY_TYPES.USER]: userIcon,
    [AD_ENTITY_TYPES.GROUP]: groupIcon,
    [AD_ENTITY_TYPES.OU]: ouIcon,
    [AD_ENTITY_TYPES.HOST]: serverIcon,
    [AD_ENTITY_TYPES.SERVER]: serverIcon,
    [AD_ENTITY_TYPES.IP]: ipIcon,
    [AD_ENTITY_TYPES.APPLICATION]: applicationIcon,
    [AD_ENTITY_TYPES.OKTA]: oktaIcon,
    [RELYING_PARTIES_TYPES.ADFS.ID]: relyingPartiesIcon,
    [RELYING_PARTIES_TYPES.PING_FED.ID]: relyingPartiesIcon,
    [AD_ENTITY_TYPES.LOCAL_ACCOUNT]: localAccountIcon
};

export const SELECTOR_TYPE = {
    ENTITY: 1,
    IP: 2,
    RESOURCE: 3
};
